/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Fornecedor {
  constructor () {
    this.fornecedor_id = uuidV4()
    this.cnpj = ''
    this.ie= ''
    this.razao = ''
    this.fantasia = ''
    this.logrado = '' // endereco + numero
    this.complemento = ''
    this.bairro = ''
    this.cidade = ''
    this.uf = ''
    this.cep = ''
    this.numero = ''
    this.fone1 = ''
    this.fone2 = ''
    this.empresa_id = sessionStorage.getItem('empresa_id')



  }
}
